import apiClient from './apiClient';

export const createinvoice = async (title, pages) => {
  try {
    const response = await apiClient.post('/contracts', { title, pages });
    return response.data;
  } catch (error) {
    console.error('Error creating invoice:', error);
    throw error;
  }
};

export const deleteinvoice = async (emailId) => {
  try {
    await apiClient.delete(`/invoice/${emailId}`);
  } catch (error) {
    throw new Error(`Failed to delete invoice with ID ${emailId}: ${error.message}`);
  }
};
